import { DashboardReviewContext, Subtask } from 'constants/interfaces'
import type { ContextRow } from 'components/NewTaskDashboard/buildContextRows'
import type { TaskInsightsResult } from 'redux/actions/tasks_v2'

export type ReviewFilter = { mode: 'subtask' | 'category'; ids: string[] }
export const EMPTY_REVIEW_FILTER: ReviewFilter = { mode: 'subtask', ids: [] }

export interface ReviewEntry {
  id: string | null
  media: boolean
  mediaIndex?: number
}

export function filterReviewSubtasks(subtasks: Subtask[], filter: ReviewFilter): Subtask[] {
  const ids = new Set(filter.ids)
  return [...subtasks]
    .sort((a, b) => a.order_index - b.order_index)
    .filter((item) => !ids.size || ids.has(filter.mode === 'subtask' ? item.st_id : item.category || ''))
}

/** Snapshot the exact visible drill-down, preserving its order and authorization scope. */
export function snapshotReviewContexts(
  rows: ContextRow[],
  results: TaskInsightsResult[],
  recurrence: string | null
): DashboardReviewContext[] {
  const seen = new Set<string>()
  return rows
    .filter((row) => {
      if (seen.has(row.contextId)) return false
      seen.add(row.contextId)
      return true
    })
    .map((row) => {
      const statuses: Record<string, number> = {}
      results
        .filter((r) => r.context_id === row.contextId && (r.recurrence_ts || null) === recurrence)
        .forEach((r) => {
          if (r.st_id) statuses[r.st_id] = r.status
        })
      return {
        contextId: row.contextId,
        taskContextId: row.taskContextId,
        name: row.name,
        status: row.status,
        statuses,
      }
    })
}
